import script from "./Applicant.vue?vue&type=script&setup=true&lang=js"
export * from "./Applicant.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__